// import useWindowDimensions from "../theme/useWindowDimensions";

const togetherPageStyles = (theme, windowDims) => {
  // const { height, width } = useWindowDimensions();
  // console.log(windowDims.height, "window dims dynmic");

  return {
    root: {
      width: '100%',
      // height: "100%",
      backgroundColor: '#11091E', //#191838
      height: windowDims.height - 1,
      overflow: 'hidden',
      // overflow: "visible !important",
      '&::-webkit-scrollbar': {
        width: 2,
        height: 2,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
        WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(104,97,88,1)',
        // outline: "1px solid slategrey",
      },
      '&:hover': {
        '&::-webkit-scrollbar': {
          width: 4,
          height: 4,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
          WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(104,97,88,1)',
        },
      },
    },

    layoutRoot: {
      width: '100%',
      height: '100%',
      backgroundColor: '#11091E', //#191838
      // overflow: "hidden",
      '&::-webkit-scrollbar': {
        width: 4,
        height: 4,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
        WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(104,97,88,1)',
        // outline: "1px solid slategrey",
      },
      '&:hover': {
        '&::-webkit-scrollbar': {
          width: 4,
          height: 4,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
          WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(104,97,88,1)',
        },
      },
    },

    leftContainer: {
      display: 'flex',
      flexDirection: 'column-reverse',
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: '0.8s',
      }),
      height: windowDims.height - 1,
      [theme.breakpoints.down('sm')]: {
        height: windowDims.height * 0.5 - 1,
      },
      [theme.breakpoints.up('sm')]: {
        height: windowDims.height - 1,
      },
    },
    streamNav: {
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#fff',
      paddingLeft: '2px',
      paddingRight: '5px',
      zIndex: '90',
      backgroundColor: 'rgb(17,9,30)',
      [theme.breakpoints.down('sm')]: {
        // display: "none ",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: '#fff',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'none ',
      },
    },
    backArrow: {
      color: 'white',
    },
    ChatContainer: {
      display: 'flex',
      // flexDirection: "column",
      backgroundColor: '#564e43',
      // zIndex: "100",

      [theme.breakpoints.down('sm')]: {
        // display: "none ",.
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#564e43',
        left: '0',
        bottom: '0px',
        zIndex: '100',
        width: windowDims.width,
        // zIndex: windowDims.zindex.zIndex,

        // maxHeight: windowDims.height * 0.5,
      },
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        flexDirection: 'column-reverse',
        backgroundColor: '#564e43',
        width: '100%',
        position: 'relative',
      },
    },
    expandIcon: {
      fill: '#fff',
      [theme.breakpoints.down('sm')]: {
        display: 'none ',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    rightContainer: {
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: '0.8s',
      }),
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#2B2C33', //#191838 11091E --old
      height: windowDims.height - 1,
      zIndex: '90',
      [theme.breakpoints.down('sm')]: {
        // maxHeight: windowDims.height * 0.5 ,
        height: windowDims.height * 0.5 - 1,
      },
      [theme.breakpoints.up('sm')]: {
        // maxHeight: windowDims.height - 1,
        height: windowDims.height - 1,
      },
    },
    rightHeadbar: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      // backgroundColor: 'black',
      zIndex: 90,
      height: 0.05 * windowDims.height,
      [theme.breakpoints.down('sm')]: {
        display: 'none ',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
      },
    },
    openButton: {
      backgroundColor: '#b19cd9',
      color: 'white',
      // padding: "16px 20px",
      border: 'none',
      cursor: 'pointer',
      opacity: '0.8',
      position: 'fixed',
      bottom: '50px',
      right: '5px',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      zIndex: 100,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        // display: "block",
        display: windowDims.displayBlock.display,
      },
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    closeButton: {
      backgroundColor: '#90103B',
      // backgroundColor: "#fff",
      color: 'white',
      // padding: "16px 20px",
      border: 'none',
      cursor: 'pointer',
      opacity: '0.8',
      position: 'absolute',
      top: '8px',
      right: '15px',
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      zIndex: 100,
      textAlign: 'left',
      // "&:hover": {
      //   backgroundColor: "#00acc1",
      // },
      [theme.breakpoints.down('sm')]: {
        // display: "none",
        display: windowDims.displayNone.display,
        // visibility: 'hidden'
      },
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    closeIcon: {
      backgroundColor: '#90103B',
      width: '22px',
      height: '22px',
      borderRadius: '50%',
      position: 'absolute',
      right: '0px',
      top: '0px',
      // padding: "5px",
    },
    transitionEff: {
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: '0.8s',
      }),
    },
    commentContainer: {
      backgroundColor: '#564e43',
      height: '100%',
    },
    image: {
      objectFit: 'cover',
      overflow: 'hidden',
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    previewContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    videoContainer: {},
    btnStyle: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    btnStyleDonate: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    btnStyleExit: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      padding: 0,
    },
    chatActive: {
      // borderStyle: 'none',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      // marginBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      '&:hover': {
        backgroundColor: '#008000',
      },
      [theme.breakpoints.down('sm')]: {
        height: '30px',
      },
    },
    btnInactive: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      // marginBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#9999a2',
      backgroundColor: '#9999a2',
      '&:hover': {
        backgroundColor: '#00acc1',
        borderColor: '#00acc1',
      },
      [theme.breakpoints.down('sm')]: {
        height: '30px',
      },
    },
    changeIcon: {
      padding: 0,
      marginRight: 0,
      height: 15,
      width: 15,
    },
    exitIcon: {
      // fill: 'red',
      // color: 'blue',
      fill: '#90103B',
      height: '100%',
      '&:hover': {
        fill: '#00acc1',
      },
    },
  };
};

export const stadiumLayoutStyles = (theme) => {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      overflow: 'hidden',
      backgroundColor: '#11091E', //#191838
      listStyle: 'none',
      width: '100%',
      '&::-webkit-scrollbar': {
        width: 2,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(104,97,88,1)',
        // outline: "1px solid slategrey",
      },
      '&:hover': {
        '&::-webkit-scrollbar': {
          width: 4,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(104,97,88,1)',
          // outline: "1px solid slategrey",
        },
      },
    },
    image: {
      // width: "30rem",
      // float: "left",
      // maxHeight: 250,
      // width: theme.spacing(40),
      // height: theme.spacing(40),
      objectFit: 'cover',
      overflow: 'hidden',
      // borderRadius: theme.spacing(4),
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    previewContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
  };
};

export const videoChatStyles = (theme) => {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      overflow: 'hidden',
      backgroundColor: '#11091E', //#191838
      listStyle: 'none',
      width: '100%',
      '&::-webkit-scrollbar': {
        width: 2,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(104,97,88,1)',
        // outline: "1px solid slategrey",
      },
      '&:hover': {
        '&::-webkit-scrollbar': {
          width: 4,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(104,97,88,1)',
          // outline: "1px solid slategrey",
        },
      },
    },
    gridList: {
      width: '100%',
      padding: 0,
    },
    icon: {
      color: 'rgba(255, 255, 255, 0.54)',
    },
    listTile: {
      overflow: 'hidden',
      padding: '0px !important',
      width: `auto !important`,
    },
    videoContainer: {
      display: 'flex',
      flexdirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      width: '100%',
      height: '100%',
    },
    boxControls: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      backgroundColor: '#000000', //564e43 --old
      color: 'black',
      overflow: 'hidden',
    },
  };
};

export default togetherPageStyles;
